import { render, staticRenderFns } from "./TableRow.vue?vue&type=template&id=2fdf73a0&"
import script from "./TableRow.vue?vue&type=script&lang=js&"
export * from "./TableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports